export default __webpack_public_path__ + "static/media/MVRDV-slide-04.5e8ee99c.jpg";